import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import Sidebar, { SidebarProps } from "./Sidebar";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

/**
 * Hamburger trigger + slide-in nav drawer, shown only below `md` where the
 * shared Sidebar collapses away entirely. Renders the same <Sidebar/>
 * (forceExpanded) inside a left Sheet so navigation stays reachable — one nav
 * definition, two placements.
 */
export const MobileNavButton = ({
  activeItem,
  className,
}: SidebarProps & { className?: string }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Close the drawer once navigation lands on a new route.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          type="button"
          aria-label={t("nav.open_menu")}
          className={cn(
            "p-2 -ml-2 rounded-lg text-[#4b5563] hover:bg-zinc-100 active:bg-zinc-200 transition-colors",
            className
          )}
        >
          <Menu className="w-6 h-6" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-[260px]">
        <SheetTitle className="sr-only">{t("nav.open_menu")}</SheetTitle>
        <Sidebar activeItem={activeItem} forceExpanded />
      </SheetContent>
    </Sheet>
  );
};

export default MobileNavButton;
